export const bookingInfoDetails = [
  {
    title: "Total Bookings",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Total Revenue",
    icon: "ri-money-dollar-circle-line",
    count: 0,
  },
  {
    title: "Cancellations",
    icon: "ri-arrow-up-s-line",
    count: 0,
  },
];

export const customersInfoDetails = [
  {
    title: "Total Users",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "New Users in Last 30days",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Monthly Active Users [MAU]",
    icon: "ri-arrow-up-s-line",
    count: 0,
  },
];

export const customerInfoDetails = [
  {
    label: "Revenue",
    value: 0,
    icon: "ri-bar-chart-2-line",
    bgColor: "#f8c6cd",
    iconColor: "#dc3545",
  },
  {
    label: "Bookings",
    value: 0,
    icon: "ri-file-list-3-line",
    bgColor: "#fef1d1",
    iconColor: "#ffc107",
  },
  {
    label: "Cancellations",
    value: 0,
    icon: "ri-close-circle-line",
    bgColor: "#f9d3d3",
    iconColor: "#dc3545",
  },
  {
    label: "Searches",
    value: 0,
    icon: "ri-search-line",
    bgColor: "#f0e7ff",
    iconColor: "#6f42c1",
  },
];

export const operatorInfoDetails = [
  {
    title: "Active Operators",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Pending Operators",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Live Buses",
    icon: "ri-computer-line",
    count: 0,
  },
];

export const posInfoDetails = [
  {
    title: "Total Bookings",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Total POS",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Live POS",
    icon: "ri-computer-line",
    count: 0,
  },
];

export const busInfoDetails = [
  {
    title: "Active Buses",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Pending Buses",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Total Buses",
    icon: "ri-computer-line",
    count: 0,
  },
];

export const couponInfoDetails = [
  {
    title: "Total Coupons Created",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Active Coupons",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Total Value of Coupons Utilized",
    icon: "ri-arrow-up-s-line",
    count: 0,
  },
];

export const referralInfoDetails = [
  {
    title: "Total Referrals",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "User Referrals",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Total Reward Distributed",
    icon: "ri-arrow-up-s-line",
    count: 0,
  },
];

export const settlementInfoDetails = [
  {
    title: "Total Amount Settled",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Settlement Count",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Failed Settlements",
    icon: "ri-computer-line",
    count: 0,
  },
];

export const transactionInfoDetails = [
  {
    title: "Total Transactions",
    icon: "ri-group-line",
    count: 0,
  },
  {
    title: "Pending Refund Transaction",
    icon: "ri-user-follow-line",
    count: 0,
  },
  {
    title: "Failed Transactions",
    icon: "ri-computer-line",
    count: 0,
  },
];
